module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "夺酒记录"
    }
  }), _vm._v(" "), _c('div', [_c('tab', {
    attrs: {
      "line-width": 2,
      "active-color": "#fc378c"
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, _vm._l((_vm.list2), function(item, index) {
    return _c('tab-item', {
      key: index,
      staticClass: "vux-center"
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('swiper', {
    attrs: {
      "height": _vm.h,
      "show-dots": false
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, [_c('not-data', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.list.length == 0),
      expression: "list.length==0"
    }]
  }), _vm._v(" "), _vm._l((_vm.list2), function(item, index) {
    return _c('swiper-item', {
      key: index
    }, [_c('view-box', {
      attrs: {
        "body-padding-bottom": "0",
        "height": "100%"
      }
    }, [(_vm.list.length > 0) ? _c('list', {
      attrs: {
        "list": _vm.list
      }
    }) : _vm._e()], 1)], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7b7906"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/takeWine/takeWine.vue
// module id = 518
// module chunks = 0